import { createStore } from 'vuex';

const store = createStore({
  state() {
    return {
      // 历史节点
      showOrderDetailsNode: false,
      // 退款说明
      showRefundInstructions: false,
      // 活动抵扣明细
      showDiscountInfo:false,
      // 选择代金券popup
      showCouponList:false,
    };
  },
  mutations: {
    setShowOrderDetailsNode(state, value) {
      console.log(` setShowOrderDetailsNode value =${value}`)
      state.showOrderDetailsNode = value;
    },

    setShowRefundInstructions(state, value) {
      console.log(` setShowRefundInstructions value =${value}`)
      state.showRefundInstructions = value;
    },

    setShowDiscountInfo(state, value) {
      console.log(` setShowDiscountInfo value =${value}`)
      state.showDiscountInfo = value;
    },

    setShowCouponList(state, value) {
      console.log(` setShowCouponList value =${value}`)
      state.showCouponList = value;
    }
  }
});

export default store;
